import React from "react";
import { ChecklistItem } from "../../utils/sessionValidation";
import "./PublishChecklist.scss";

type Props = {
  items: ChecklistItem[];
};

const PublishChecklist: React.FC<Props> = ({ items }) => {
  const pending = items.filter((i) => !i.ok).length;
  const pillLabel = pending === 0 ? "Ready" : `${pending} left`;
  const pillBg = pending === 0 ? "#E7F5EF" : "#F2EBE1";
  const pillFg = pending === 0 ? "#238A5E" : "#9A7A3A";

  return (
    <div className="wf-checklist">
      <div className="wf-checklist__head">
        <div className="wf-checklist__title">Publish checklist</div>
        <span
          className="wf-checklist__pill"
          style={{ background: pillBg, color: pillFg }}
        >
          {pillLabel}
        </span>
      </div>
      <ul>
        {items.map((item) => (
          <li key={item.key}>
            <span
              className={`wf-checklist__mark${item.ok ? " is-ok" : " is-pending"}`}
              aria-hidden
            >
              {item.ok ? (
                <svg
                  width="9"
                  height="9"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3.6"
                  strokeLinecap="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              ) : (
                <span className="wf-checklist__dot" />
              )}
            </span>
            <span
              className="wf-checklist__text"
              style={{ color: item.ok ? "#5C554E" : "#242220" }}
            >
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PublishChecklist;
